// test2439
(2439 && 0);
